import request from '@/utils/request'

// 查询维修材料列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/material/item/page',
        method: 'get',
        params: query,
    })
}
// 查询维修材料详细
export function getObj(id) {
    return request({
        url: '/upkeep/material/item/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修材料
export function addObj(data) {
    return request({
        url: '/upkeep/material/item/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用状态
export function statusObj(data) {
    return request({
        url: '/upkeep/material/item/status',
        method: 'post',
        data: data,
    })
}
// 修改维修材料
export function putObj(data) {
    return request({
        url: '/upkeep/material/item/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修材料
export function delObj(data) {
    return request({
        url: '/upkeep/material/item/delete',
        method: 'post',
        data: data,
    })
}
